import ThreeD from "../ThreeD";

export default class Custom extends ThreeD {
	public static code = "threed_hollowshelf";
}
